var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home-editor",attrs:{"id":'editor' + _vm.editorKey}})])
}
var staticRenderFns = []

export { render, staticRenderFns }